"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _reactModal = _interopRequireDefault(require("react-modal"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var AlertModal = /*#__PURE__*/function (_PureComponent) {
  function AlertModal(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, AlertModal);
    _this = _callSuper(this, AlertModal, [props]);
    _this.state = {
      modalIsOpen: false,
      buttonOne: {},
      buttonTwo: {},
      header: '',
      text: ''
    };
    return _this;
  }
  (0, _inherits2["default"])(AlertModal, _PureComponent);
  return (0, _createClass2["default"])(AlertModal, [{
    key: "closeModal",
    value: function closeModal() {
      this.setState({
        modalIsOpen: false
      });
    }
  }, {
    key: "openModal",
    value: function openModal(content) {
      this.setState({
        modalIsOpen: true,
        buttonOne: content.buttonOne,
        buttonTwo: content.buttonTwo,
        header: content.header,
        text: content.text
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$state = this.state,
        buttonOne = _this$state.buttonOne,
        buttonTwo = _this$state.buttonTwo,
        header = _this$state.header,
        text = _this$state.text;
      return /*#__PURE__*/_react["default"].createElement(_reactModal["default"], {
        isOpen: this.state.modalIsOpen,
        overlayClassName: "react-modal-overlay",
        className: "react-modal-content day8-modal-container",
        onRequestClose: function onRequestClose() {
          return _this2.closeModal();
        },
        contentLabel: "Base Modal"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "day8-modal-content"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "react-modal-close",
        onClick: function onClick() {
          return _this2.closeModal();
        }
      }, /*#__PURE__*/_react["default"].createElement("i", {
        className: "material-icons grey"
      }, "close")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "react-modal-text"
      }, /*#__PURE__*/_react["default"].createElement("h4", null, header), /*#__PURE__*/_react["default"].createElement("p", null, text)), /*#__PURE__*/_react["default"].createElement("div", {
        className: "react-modal-buttons"
      }, buttonOne && /*#__PURE__*/_react["default"].createElement("button", {
        className: "btn btn-".concat(buttonOne.type),
        onClick: function onClick() {
          return buttonOne.onClick();
        }
      }, this.state.buttonOne.text), buttonTwo && /*#__PURE__*/_react["default"].createElement("button", {
        className: "btn btn-".concat(buttonTwo.type),
        onClick: function onClick() {
          buttonTwo.onClick();
        }
      }, buttonTwo.text))));
    }
  }]);
}(_react.PureComponent);
var _default = exports["default"] = AlertModal;